.root {
  display: inline-flex;
  position: relative;
}

// The bell keeps its default colour whether or not there is unread mail: the
// count badge is the unread signal, and the accessible name spells the number
// out ("Notifications, 3 unread"), so the state is never carried by colour
// alone even without a tinted icon.
.icon {
  height: 16px;
  width: 16px;
}

.badgeAnchor {
  pointer-events: none;
  position: absolute;
  right: -4px;
  top: -4px;
}
